import { EditorProps } from '@tiptap/pm/view';

import { stripHtmlTags } from './editor/extensions/utils';

export const defaultEditorProps: EditorProps = {
  attributes: {
    class: `font-default focus:outline-hidden max-w-full [data-node-view-wrapper]:inline`,
  },
  handleDOMEvents: {
    keydown: (_view, event) => {
      // prevent default event listeners from firing when slash command is active
      if (['ArrowUp', 'ArrowDown', 'Enter'].includes(event.key)) {
        const slashCommand = document.querySelector('#slash-command');
        if (slashCommand) {
          return true;
        }
      }
      return false;
    },
  },
  // Clean pasted HTML before ProseMirror parses it.
  // Replaces the previous handlePaste + synthetic ClipboardEvent re-dispatch
  // which broke after the TipTap 2.27 upgrade (ProseMirror no longer
  // processes synthetic paste events reliably).
  transformPastedHTML: (html) => {
    return stripHtmlTags(html);
  },
};
